import React, { useState, useEffect,useCallback } from 'react';
import api from '../api/axiosConfig';
import { useAuth } from '../context/AuthContext';
import Layout from './Layout';
import AttendanceList from './AttendanceList';

const AttendancePage = () => {
  const [employeeId, setEmployeeId] = useState('');
  const [pin, setPin] = useState('');
  const [message, setMessage] = useState('');
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const { isAuthenticated, getAccessToken } = useAuth();

   // Wrap your fetch function in useCallback to stabilize its reference.
   const fetchAttendanceRecords = useCallback(async () => {
    if (!isAuthenticated || !getAccessToken()) return;

    try {
      const response = await api.get('/attendance/records');
      setAttendanceRecords(response.data);
    } catch (error) {
      console.error('Error fetching attendance records:', error);
    }
  }, [isAuthenticated]); 

  useEffect(() => {
    fetchAttendanceRecords();
  }, [fetchAttendanceRecords]);

  const handleTimeIn = async () => {
    if (!isAuthenticated || !getAccessToken()) return;

    setMessage('');
    try {
      const response = await api.post('/attendance/timein', { employeeId, pin });
      setMessage(response.data.message || 'Time in successful');
      await fetchAttendanceRecords(); // Refresh attendance list
    } catch (error) {
      console.error('Time in error:', error);
      setMessage(error.response?.data?.error || 'Error during time in');
    }
  };

  const handleTimeOut = async () => {
    if (!isAuthenticated || !getAccessToken()) return;

    setMessage('');
    try {
      const response = await api.post('/attendance/timeout', { employeeId, pin });
      setMessage(response.data.message || 'Time out successful');
      await fetchAttendanceRecords(); // Refresh attendance list
    } catch (error) {
      console.error('Time out error:', error);
      setMessage(error.response?.data?.error || 'Error during time out');
    }
  };

  return (
    <Layout role="admin">
      <div className="max-w-3xl mx-auto bg-white rounded shadow p-6 mt-6">
        <h1 className="text-2xl font-bold mb-4">Employee Attendance</h1>

        <div className="flex flex-col space-y-4 mb-4">

        <label className="block mb-2 text-xs">Employee ID</label>
          <input
            className="border p-2 rounded"
            type="text"
            placeholder="Employee ID"
            value={employeeId}
            onChange={(e) => setEmployeeId(e.target.value)}
          />

          <label className="block mb-2 text-xs">PIN</label>
          <input
            className="border p-2 rounded"
            type="password"
            placeholder="PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
          />
          <div className="flex space-x-2">
            <button
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
              onClick={handleTimeIn}
            >
              Time In
            </button>
            <button
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              onClick={handleTimeOut}
            >
              Time Out
            </button>
          </div>
        </div>

        {message && (
          <p className="text-sm font-semibold text-red-600 mb-2">{message}</p>
        )}

        {/* Pass attendanceRecords to AttendanceList */}
        <AttendanceList attendanceRecords={attendanceRecords} />
      </div>
    </Layout>
  );
};

export default AttendancePage;
